import { Component, OnInit, ViewChild } from '@angular/core';
import { Message, MessageAttachment } from 'app/core/model/entity-model';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { BaseDetailComponent, SharedModule } from 'app/shared/shared.module';
import { DxHtmlEditorComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import { environment } from 'environments/environment';
import _ from 'lodash';
import moment from 'moment';
import { Subject } from 'rxjs';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-message-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.scss'],
    standalone: true,
    imports: [DevExtremeModule, SharedModule],
})
export class DetailComponent extends BaseDetailComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    message: Message;
    mode: 'drafts' | 'sent-items';
    groups: any[];
    fromOptions: any = ['General Email'];
    from: any;
    baseHref = environment.baseHref;
    serviceName = environment.serviceName;
    froalaOptions = {
        key: environment.froalaKey,
        heightMin: 250,
        heightMax: 750,
        imageUploadURL: `${environment.serviceName}/api/utility/uploadMessageImage`,
        useClasses: false,
        events: {
            initialized: (editor) => {
                if (this.mode !== 'drafts' && !this.appInfo.graafschap) editor.getEditor().edit.off();
            },
        },
    };
    showAsDialog = false;
    readOnly: boolean = false;
    batch: any;
    deaconsGroupId: number;
    uploadHeaders: any;
    isMessagesAdmin: boolean = false;
    canSendOld = false;

    @ViewChild('editor') editor: DxHtmlEditorComponent;

    async ngOnInit() {

        this.uploadHeaders = { Authorization: 'Bearer ' + this.auth.currentUser.jwtToken };
        this.groups = await this.getGroups();
        this.fromOptions.push(this.auth.currentUser.userName);
        if (!this.showAsDialog) {
            this.mode = this.route.snapshot.data['mode'];
            this.route.params.subscribe(async (params) => {
                this.key = params['id'];

                if (this.key === 'new') {
                    this.message = this.uow.messages.createEntity({ created: moment().toDate() });
                    console.log('here');
                    await this.uow.commit();
                } else {
                    await this.getData();
                    console.log('here2');
                }
                this.entity = this.message;
            });
        } else {
            (this.message as any).from = 'General Email';
            this.entity = this.message;
        }
        this.readOnly = this.mode !== 'drafts';
        this.isMessagesAdmin = this.auth.hasRole('Messages:Admin');
        this.canSendOld = this.auth.currentUser.userName === 'mreimink';
        console.log('isMessagesAdmin', this.isMessagesAdmin, this.entity, this.message);
    }

    onFromSelectionChanged = (e) => {
        this.message.fromUserId = this.auth.currentUser.id;
    };

    async getData() {
        this.message = await this.uow.messages.byId(this.key, 'attachments');
    }

    private getGroups() {
        return this.uow.groups.all('name');
    }

    async send(method?: string) {
        const dialogResult = await (<Promise<boolean>>confirm('Are you sure you want to send this message?', 'Ready to Send'));
        if (!dialogResult) return;
        if (this.showAsDialog) await this.uow.commit();

        this.appInfo.pleaseWait = true;
        if (this.appInfo.graafschap) {
            if ((this.message as any).from !== 'General Email') {
                const userEmail = _.find(this.uow.lookups.users, { id: this.auth.currentUser.id }).email;
                if (!userEmail) {
                    this.appInfo.pleaseWait = false;
                    await alert(`The selected username has no associated email address.  Use General or contact admin.`, `Error`);
                    return;
                }
                this.message.privateEmail = true;
            }
        }
        if (method === 'sendgrid') {
            await this.utility.sendMessageViaSendGrid(this.message.id, this.message.privateEmail);
        } else {
            await this.utility.sendMessage(this.message.id, this.message.privateEmail);
        }
        this.appInfo.pleaseWait = false;
        await (<Promise<any>>alert('Message sent!', 'Complete'));
        await this.uow.commit();
        if (this.showAsDialog) this.closeDialog(null, true);
        else this.close();
    }

    async closeDialog(cancel?: boolean, success?: boolean) {
        if (cancel) {
            const result = await confirm('Are you sure you want to cancel changes?', 'Cancel Changes');
            if (!result) return;
        }
        if (!success) this.uow.rollback();
        this.result.next({ success: success });
    }

    async getInput(prompt: string, mode: string, array?: any[], value?: any): Promise<any> {
        let modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Graafschap Church',
                dialogPrompt: prompt,
                dialogValueArray: array,
                dialogValue: value,
                mode: mode,
            },
        });
        const promise = new Promise<any>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    resolve(result.value);
                }
                modalRef.hide();
                resolve(null);
            });
        });
        return promise;
    }

    async copy() {
        const dialogResult = await (<Promise<boolean>>confirm('Do you want to make a draft copy of this message?', 'Copy Message'));
        if (!dialogResult) return;

        const message = this.message;

        const announcements = message.subject.toLowerCase().indexOf('announcement') > 0;
        const prayerEmail = message.subject.toLowerCase().indexOf('prayer') > 0;
        let newEmailSubject = '';
        if (announcements || prayerEmail) {
            const today = new Date();
            if (announcements) {
                const sunday = moment(today).isoWeekday(7).format('MMMM DD');
                newEmailSubject = `${sunday} Announcements`;
                newEmailSubject = await this.getInput('New Message Subject', 'text', null, newEmailSubject);
            }
            if (prayerEmail) {
                const wednesday = moment(today).isoWeekday(3).format('MMMM DD');
                newEmailSubject = `${wednesday} Prayer Email`;
                newEmailSubject = await this.getInput('New Message Subject', 'text', null, newEmailSubject);
            }
        }

        this.appInfo.pleaseWait = true;
        const newMessage = this.uow.messages.createEntity();
        newMessage.created = moment().toDate();
        newMessage.subject = !!newEmailSubject && newEmailSubject !== '' ? newEmailSubject : message.subject + ' - copy';
        newMessage.body = this.message.body;
        newMessage.toGroupId = this.message.toGroupId;
        this.message.attachments.forEach((a) => {
            const newAttachment = this.uow.manager.createEntity('MessageAttachment') as MessageAttachment;
            newAttachment.name = a.name;
            newAttachment.fileName = a.fileName;
            newAttachment.message = newMessage;
        });
        await this.uow.commit();

        this.appInfo.pleaseWait = false;
        this.router.navigate(['../../drafts/' + newMessage.id], { relativeTo: this.route });
    }

    async deleteAttachment(attachment: any) {
        const dialogResult = await (<Promise<boolean>>confirm('Are you sure you want to delete this attachment?', 'Delete Attachment'));
        if (!dialogResult) return;

        this.appInfo.pleaseWait = true;
        attachment.entityAspect.setDeleted();
        await this.uow.commit();
        this.appInfo.pleaseWait = false;
    }

    async uploadStarted() {
        await this.uow.commit();
        this.key = this.message.id;
    }

    attachmentUploaded() {
        this.getData();
    }
}
